import React from "react";
import { useContext } from "react";
import { useTranslation } from 'react-i18next';

import "./hubContact.scss";

import SupportModal from "components/modals/SupportModal";
import { ModalContext } from "components/ModalContext";
import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const HubContactButton = ({
  onHideHelp,
}) => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);

  const handleCloseModal = () => {
    handleModal(null, true);
  };

  const handleClick = () => {
    handleModal(
      <SupportModal closeModal={handleCloseModal} />,
      false,
      true
    );
  };

  return (
    <div className="hub-contact-btn">
      <p>{t('do_you_have_problem')}</p>

      <UniversalButton
        label={t('contact_support')}
        size="lg"
        labelColor="white"
        labelHoverColor="white"
        backgroundColor="orange"
        backgroundHoverColor="orange-light"
        isFullWidth
        onClick={handleClick}
      />

      <button
        className="hub-contact-btn__close"
        onClick={onHideHelp}
      >
        <CloseIcon className="hub-contact-btn__close_icon" />
      </button>
    </div>
  );
};

export default HubContactButton;
